export * from './qr-view-dialog.component';